import { Grid } from '@mui/material';
import { GlobalsHeaderCell, TypographyUppercase } from '../CoverageGridCell';
import { Toggle } from '../../../../../../../agencies/quotes/PrimeX/quoteDetails/components/Toggle';

interface GlobalHeaderProps {
  handleShowAllDetails: () => void;
  showAllDetails: boolean;
}

export const GlobalHeader = ({
  handleShowAllDetails,
  showAllDetails,
}: GlobalHeaderProps) => {
  return (
    <Grid container>
      <GlobalsHeaderCell item sm={3} sx={{ padding: '1rem' }}>
        <TypographyUppercase variant="subtitle2" color="primary">
          Global Options
        </TypographyUppercase>
      </GlobalsHeaderCell>

      <GlobalsHeaderCell item sm={3}>
        <TypographyUppercase variant="subtitle2" color="primary">
          Policy
        </TypographyUppercase>
      </GlobalsHeaderCell>

      <GlobalsHeaderCell item sm={3}>
        <TypographyUppercase variant="subtitle2" color="primary">
          Endorsement
        </TypographyUppercase>
      </GlobalsHeaderCell>

      <GlobalsHeaderCell
        item
        sm={3}
        sx={{ display: 'flex', alignItems: 'right' }}
      >
        <Toggle
          toggleOn={showAllDetails}
          handleToggle={handleShowAllDetails}
          label="Show All"
        />
      </GlobalsHeaderCell>
    </Grid>
  );
};
